import React, { useEffect, useState } from "react";
import AdminSidebar from "./AdminSidebar";
import AdminHeader from "./AdminHeader";
import axios from "axios";
import { base_url } from "./AgentWhitelist";
import { useLocation } from "react-router-dom";

const AccountStatement = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(!(window.innerWidth < 768));
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  const [casino, setCasino] = useState([]);
  const [fullCasino, setFullCasino] = useState([]);
  const [search, setSearch] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [agentId, setAgentId] = useState(null);
  const [agent, setAgent] = useState("");

  // ⭐ Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  // ⭐ GET agent ID from navigation/state
  const location = useLocation();
  console.log(location?.state?.id,"kfk")

  useEffect(() => {
    if (location?.state?.id) {
      setAgentId(location.state.id);
      setAgent(location.state.id);
    }
  }, [location.state]);

 

  // ⭐ Fetch API
  const casinoData = async () => {
    try {
      const auth = localStorage.getItem("admin");

      const response = await axios.get(base_url + `/api/webapi/agentChipsData`, {
        headers: {
          Authorization: auth,
          "content-type": "application/json",
        },
      });

      if (response?.data?.success) {
        const data = response?.data?.result;
        setCasino(data);
        setFullCasino(data);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {

    casinoData();
  }, []);

  // ⭐ Search + Filter Function
  const handleSearch = (e) => {
    setSearch(e.target.value);
  };

  const handleFilter = () => {
    let filteredData = [...fullCasino];

    if (search !== "") {
      filteredData = filteredData.filter(
        (row) =>
          row.id_user.toString().toLowerCase().includes(search.toLowerCase()) ||
          row.clientId.toString().toLowerCase().includes(search.toLowerCase()) ||
          row.client_name.toLowerCase().includes(search.toLowerCase())
      );
    }

    if (startDate && endDate) {
      const start = new Date(startDate + "T00:00:00");
      const end = new Date(endDate + "T23:59:59");

      filteredData = filteredData.filter((row) => {
        const rowDate = new Date(row.time);
        return rowDate >= start && rowDate <= end;
      });
    }

    setCasino(filteredData);
  };

  useEffect(() => {
    handleFilter();
    setCurrentPage(1); // reset pagination after filtering
  }, [search, startDate, endDate]);

  // ⭐ Responsive sidebar handler
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      if (!mobile) setIsSidebarOpen(true);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // ⭐ PAGINATION LOGIC
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = casino.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(casino.length / itemsPerPage);

  return (
    <div className="wrapper bg-light">
      <AdminSidebar
        isSidebarOpen={isSidebarOpen}
        toggleSidebar={toggleSidebar}
        isMobile={isMobile}
      />
      <AdminHeader
        toggleSidebar={toggleSidebar}
        isSidebarOpen={isSidebarOpen}
        isMobile={isMobile}
      />

      <div
        className={`content-wrapper p-1 ${
          !isMobile && isSidebarOpen ? "" : "open-content-wrapper"
        }`}
        style={{ marginLeft: !isMobile && isSidebarOpen ? "" : "0" }}
      >
        <div className={`main-content ${isSidebarOpen ? "with-sidebar" : ""}`}>
          <div className="container-fluid py-4">

            <div className="d-flex align-items-center gap-2 mb-3">
              <h3 className="text-dark fs-5 m-0">Chip Statement of Agent:</h3>
              <span className="fw-bold text-primary fs-4">{agent}</span>
            </div>

            {/* 🔍 Search & Filter Section */}
            <div className="row g-3 mb-3">
              {/* <div className="col-md-4">
                <input
                  type="text"
                  placeholder="Search by ID / Client ID / Name"
                  className="form-control"
                  value={search}
                  onChange={handleSearch}
                />
              </div> */}
              <div className="col-md-3">
                <input
                  type="date"
                  className="form-control"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                />
              </div>
              <div className="col-md-3">
                <input
                  type="date"
                  className="form-control"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                />
              </div>
              <div className="col-md-2">
                <button
                  className="btn btn-outline-secondary w-100"
                  onClick={() => {
                    setCasino(fullCasino);
                    setSearch("");
                    setStartDate("");
                    setEndDate("");
                    setCurrentPage(1);
                  }}
                >
                  Reset
                </button>
              </div>
            </div>

            {/* 📊 Table */}
            {casino.length === 0 ? (
              <div className="text-center py-5 text-muted">No Records Found</div>
            ) : (
              <>
                <div className="table-responsive shadow-sm rounded bg-white p-3 w-100">
                  <table className="table-hover align-middle mb-0 w-100 overflow-auto">
                    <thead className="table-dark">
                      <tr className="text-center border border-black">
                        {/* <th>ID</th> */}
                        <th>Amount</th>
                        {/* <th>My Old Balance</th>
                        <th>My New Balance</th> */}
                        <th>Client ID</th>
                        <th>Client Name</th>
                        <th>Client Role</th>
                        <th>Client Old Balance</th>
                        <th>Client New Balance</th>
                        <th>Time</th>
                      </tr>
                    </thead>

                    <tbody>
                      {currentItems.map((row) => (
                        <tr key={row.id} className="text-center text-nowrap border border-dark">
                          {/* <td>{row.id_user}</td> */}
                          <td>{row.amount}</td>
                          {/* <td>{row.old_balance}</td>
                          <td>{row.new_balance}</td> */}
                          <td>{row.clientId}</td>
                          <td>{row.client_name}</td>
                          <td>{row.client_role}</td>
                          <td>{row.client_old_balance}</td>
                          <td>{row.client_new_balance}</td>
                          <td>{new Date(row.time).toLocaleString("en-IN")}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {/* ⭐ Pagination Buttons */}
                <div className="d-flex justify-content-center mt-3 gap-2">
                  <button
                    className="btn btn-sm btn-dark"
                    disabled={currentPage === 1}
                    onClick={() => setCurrentPage(currentPage - 1)}
                  >
                    Prev
                  </button>

                  {[...Array(totalPages)].map((_, i) => (
                    <button
                      key={i}
                      className={`btn btn-sm ${
                        currentPage === i + 1 ? "btn-primary" : "btn-outline-primary"
                      }`}
                      onClick={() => setCurrentPage(i + 1)}
                    >
                      {i + 1}
                    </button>
                  ))}

                  <button
                    className="btn btn-sm btn-dark"
                    disabled={currentPage === totalPages}
                    onClick={() => setCurrentPage(currentPage + 1)}
                  >
                    Next
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountStatement;